import React from "react";
import { Link } from "react-router-dom";

const MegaMenu = ({ data }) => {
  const handleClick = (e, link) => {
    if (link && link.includes('#')) {
      e.preventDefault();
      const [path, hash] = link.split('#');
      
      if (window.location.pathname === path) {
        const element = document.getElementById(hash);
        if (element) {
          const offset = 110; // Offset for navbar height
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({ top: offsetPosition, behavior: "smooth" });
        }
      } else {
        window.location.href = link;
      }
    }
  };

  return (
    <div className="dropdown-menu">
      <div className="dropdown-columns">
        {data.map((section, index) => (
          <div key={index} className={`dropdown-column ${section.type || ""}`}>
            <h4>{section.title}</h4>
            {section.items.map((item, i) => (
              <Link
                key={i}
                to={item.link || "/"}
                onClick={(e) => handleClick(e, item.link)}
              >
                {item.name}
              </Link>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MegaMenu;